export default [
  {
    params: {
      path: "/dashboard",
      name: "Dashboard",
    },
    defaultComponentPath: "Pages/Dashboard",
    navs: true,
  },
  {
    params: {
      path: "/schedule",
      name: "Schedule",
    },
    defaultComponentPath: "Pages/Schedule",
    navs: true,
  },
  {
    params: {
      path: "/timeoff",
      name: "TimeOff",
    },
    defaultComponentPath: "Pages/TimeOff",
    navs: true,
  },
  {
    params: {
      path: "/announcement",
      name: "Announcement",
    },
    defaultComponentPath: "Pages/Announcement",
    navs: true,
  },
  {
    params: {
      path: "/reports",
      name: "Reports",
    },
    defaultComponentPath: "Pages/Reports",
    navs: true,
  },
  {
    params: {
      path: "/clients",
      name: "Clients",
    },
    defaultComponentPath: "Pages/Clients",
    navs: true,
  },
  {
    params: {
      path: "/clients/create",
      name: "ClientCreate",
    },
    defaultComponentPath: "Pages/Client/ClientAdd",
    navs: true,
  },
  {
    params: {
      path: "/clients/:id/edit",
      name: "ClientEdit",
    },
    defaultComponentPath: "Pages/Client/ClientEdit",
    navs: true,
  },
  {
    params: {
      path: "/clients/:id",
      name: "ClientDetail",
    },
    defaultComponentPath: "Pages/Client/ClientDetail",
    navs: true,
  },
  {
    params: {
      path: "/storage",
      name: "Storage",
      showTitle: true,
    },
    defaultComponentPath: "Pages/Storage",
    navs: true,
  },
  {
    params: {
      path: "/password-vault",
      name: "PasswordVault",
      showTitle: true,
    },
    defaultComponentPath: "Pages/PasswordVault",
    navs: true,
  },
  {
    params: {
      path: "/vault-folder",
      name: "VaultFolder",
      showTitle: true,
    },
    defaultComponentPath: "Pages/VaultFolder",
    navs: true,
  },
  {
    params: {
      path: "/jobs",
      name: "TaskList",
      showTitle: true,
    },
    defaultComponentPath: "Pages/TaskList",
    navs: true,
  },
  {
    params: {
      path: "/jobs/client/:clientId",
      name: "TaskListClient",
    },
    defaultComponentPath: "Pages/TaskList",
    navs: true,
  },
  {
    params: {
      path: "/time-clock",
      name: "TimeClock",
    },
    defaultComponentPath: "Pages/TimeClock",
    navs: true,
  },
  {
    params: {
      path: "/bids/create",
      name: "QuotesCreate",
    },
    defaultComponentPath: "Pages/Quotes/Form",
    navs: true,
  },
  {
    params: {
      path: "/bids/:quoteId/edit",
      name: "QuoteEdit",
    },
    defaultComponentPath: "Pages/Quotes/Form",
    navs: true,
  },
  {
    params: {
      path: "/bids/:quoteId/clone",
      name: "QuoteClone",
    },
    defaultComponentPath: "Pages/Quotes/FormClone",
    navs: true,
  },
  {
    params: {
      path: "/bids/client/:clientId",
      name: "QuotesClient",
    },
    defaultComponentPath: "Pages/Quotes",
    navs: true,
  },
  {
    params: {
      path: "/bids",
      name: "Quotes",
    },
    defaultComponentPath: "Pages/Quotes",
    navs: true,
  },
  {
    params: {
      path: "/items",
      name: "Item List",
    },
    defaultComponentPath: "Pages/Item",
    navs: true,
  },
  {
    params: {
      path: "/users",
      name: "Users",
    },
    defaultComponentPath: "Pages/Users",
    navs: true,
  },
  {
    params: {
      path: "/user-groups",
      name: "UserGroup",
    },
    defaultComponentPath: "Pages/User/UserGroup",
    navs: true,
  },
  {
    params: {
      path: "/login",
      name: "pages/authentication/LoginPage",
      meta: { layout: "auth" },
    },
    defaultComponentPath: "Pages/Authentication/Login/Login",
  },
  {
    params: {
      path: "/forgot-password",
      name: "pages/authentication/ForgotPasswordPage",
      meta: { layout: "auth" },
    },
    defaultComponentPath: "Pages/Authentication/ForgotPassword/ForgotPassword",
  },
  {
    params: {
      path: "/signup",
      name: "pages/authentication/SignupPage",
      meta: { layout: "auth" },
    },
    defaultComponentPath: "Pages/Authentication/Signup/Signup",
  },  
  {
    params: {
      path: "/account",
      name: "Account",
    },
    defaultComponentPath: "Pages/Account",
    navs: true,
  },
  //  {
  //    params: {
  //      path: "*",
  //      name: "PageNotFound",
  //      meta: { layout: "full" },
  //    },
  //    defaultComponentPath: "Pages/Errors/Error404",
  //  },
];
